import React, { useEffect } from 'react';
import LogoIcon from '../../../img/svg/logo-icon.svg'
import Logo from '../../../img/svg/logo-white.svg'
import LogoGold from '../../../img/logo-gold.svg'

import {
  Container,
  Header,
  TextHeader,
  Img,
  NameRow,
  ImgLogo,
  Description,
  FooterReport,
  TitleModule,
} from '../../CFP/Weekly/PDF/Class/styles'

import { useDispatch, useSelector } from 'react-redux'
import { actions as studentActions } from '../../../redux/modules/student';
import { Col } from 'antd';
import BarchartH from '../../CFP/Report/Charts/BarChartH/BarChartH';
import BartChartV from '../../CFP/Report/Charts/BartChartV/BartChartV';
import { Content } from '../../CFP/styles';
import LegendChart from '../../CFP/Report/Charts/SubtitleChart';
import ReportBreakPage from '../../CFP/Report/ReportBreakPage';

// ReportText
import ReportText from '../../CFP/Report/TextDescription';

import {
  getDefaultParams,
  getSusgestionByScoreToro,
  TYPE_SCORE_INFORMATION_REPORT_WEEKLY,
  TYPE_SCORE_INFORMATION_REPORT_PDF
} from '../../CFP/common';

import { isEmpty, isNaN } from 'lodash';
import Score from '../../CFP/Weekly/PNG/Score';
import { fetchGeneralText } from '../../../redux/api/class';
import useExamType from '../../../hooks/useExamType';
import { getModulesWithPageBreaks } from './cfa-modules-content';
import { RECOMMENDED_CFP, RECOMMENDED_CFA, MODULE_COUNT } from '../../CFP/constants/examRecommendations';

const RECOMMENDED_GOALS = {
  CFA: RECOMMENDED_CFA.map(r => r.value),
  CFP: RECOMMENDED_CFP.map(r => r.value)
};

function ExamWeeklyReport() {
  const [textData, setTextData] = React.useState("");
  const examConfig = useExamType();
  const { reportSimulado: report, scoreToroInformation } = useSelector((state) => state.student);
  const suggestion = getSusgestionByScoreToro(scoreToroInformation, Number(((report?.score?.score ?? 0) * 100).toFixed(1)))

  const dispatch = useDispatch();
  useEffect(() => {
    const { userId, courseId, classId, media, start, end, kind, classes } = getDefaultParams(window.location.search);

    dispatch(studentActions.handleExamSimulado(userId, courseId, classId, media, start, end, kind, classes, examConfig.examType));

    dispatch(studentActions.getScoreToroSugestionsByTypes(
      examConfig.courseCategory,
      TYPE_SCORE_INFORMATION_REPORT_PDF,
      TYPE_SCORE_INFORMATION_REPORT_WEEKLY
    ));
  }, [dispatch, examConfig.courseCategory, examConfig.examType]);

  useEffect(() => {
    (async () => {
      try {
        const filters = {
          typeReportId: 1,
          courseCategoryId: 15,
          categoryReportId: 2
        }
        const textDataApi = await fetchGeneralText(filters)
        if (textDataApi[0]?.content !== undefined) {
          setTextData(textDataApi[0]?.content)
        }
      } catch (error) {
        console.error('Erro ao buscar texto do relatório semanal:', error)
        setTextData('')
      }
    })()
  }, [examConfig.courseCategory])

  const modulePerfomance = report?.module_performance;
  const improve = report?.you_can_improve_module;
  const reportDone = report?.test?.done ?? [];
  const reportExists = !isEmpty(reportDone);

  const textoInicial = textData?.split("##imagem_relatório##")[0] || ""
  const dataGrafico = textData?.split("##imagem_relatório##")[1]?.split("##data_imagem:")[1]?.split("##")[0] || ""
  const textoFinal = textData?.split("##")[textData?.split("##")?.length-1] || ""

  const reportProvaResult =
    report !== undefined
      && reportExists
      && !isNaN(Math.round(reportDone[0]?.prova)) ? Math.round(report?.test?.done[0]?.prova) : 0;
  const includeRevisionByExam = examConfig.examType === 'cfp' ? true : undefined;
  
  // Total de provas disponíveis - MESMA LÓGICA do componente Score "Provas Feitas"
  const totalReportsAvailable = report?.test?.to_be_done?.[0]?.prova ?? 0;

  if(modulePerfomance) {
    const moduleCount = examConfig.examType === 'CFA' ? MODULE_COUNT.cfa : MODULE_COUNT.cfp;
    const allModules = Array.from({ length: moduleCount }, (_, i) => `M${i + 1}`);
    
    allModules.forEach(moduleName => {
      if(!modulePerfomance) return;
      if(!modulePerfomance.find(module => moduleName === module?.module)) {
        improve.push({module: moduleName, total: 0, tipo_prova: 'AULA'});
      }
    });

    improve.sort(function (a, b) {
      // Extrai o número do módulo (ex: "M1" -> 1, "M10" -> 10)
      const numA = parseInt(a.module.replace(/\D/g, ''), 10);
      const numB = parseInt(b.module.replace(/\D/g, ''), 10);
      return numA - numB;
    });
  }

  const improveMessage = (improve = []) => {
    if (isEmpty(improve)) return '';
    const total = (improve ?? []).length - 1;
    return improve.map((item, i) => {
      return (i > 0 && i < total ? ', ' : (i === total ? ' e ' : '')) + (item.tipo_prova === 'AULA' ? item.module : '');
    });
  };

  const recomendedPerformance = (modulePerfomance = false) => {
    if (!modulePerfomance) return false;

    const goals = RECOMMENDED_GOALS[examConfig.examType] || RECOMMENDED_GOALS.CFP;
    
    return modulePerfomance
      .map((module, i) => ((module?.total * 100) < goals[i] ? i : null))
      .filter(i => i !== null);
  }

  const truncateText = (text, maxLength = 50) => {
    if (!text) return '';
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  }

  return (
    <>
      <Header>
        <Img src={Logo} alt="logo" />
      </Header>

      <Container>
        <NameRow justify="space-between">
          <Col>
            <h1>Olá {report?.name} :)</h1>
            <p style={{ fontSize: '2.34vw'}}>Este é o seu desempenho até agora no curso para o CFA Level 1.</p>
          </Col>
          <Col>
            <ImgLogo src={LogoIcon} alt="logo" />
          </Col>
        </NameRow>

        <TextHeader>
          <div dangerouslySetInnerHTML={{ __html: textoInicial }} />
        </TextHeader>
        <Content>
          {
            typeof reportProvaResult === 'number' && (
              <TextHeader style={{ width: '100%', textAlign: 'center' }}>Você completou os exercícios de <strong>
                {reportProvaResult} provas</strong> das <strong> {totalReportsAvailable} disponíveis.</strong>
              </TextHeader>
            )
          }

          {
            typeof reportProvaResult === 'number' && (
              <BarchartH
                zIndex={1}
                displaySubtitle={'none'}
                displayAvaliable={"flex"}
                classNumber={reportProvaResult}
                percent={Number(((reportProvaResult / totalReportsAvailable) * 100).toFixed(1))}
                percentText={`${reportProvaResult}`}
                colorbk1={'#000A66'}
                total={totalReportsAvailable}
                textAvaliableDate={`* ${dataGrafico.replace("<p>", "").replace("</p>", "")}`}
              />
            )
          }
        </Content>

        <Description style={{ marginBottom: '2.816vw' }}>
          <div dangerouslySetInnerHTML={{ __html: textoFinal }} />
        </Description>

        <ReportBreakPage />

        <ReportText type='graph'>Desempenho geral</ReportText>

        <div style={{ marginBottom: '3vw', width: '100%' }}>
          <Score />
        </div>

        <ReportText type='description'>
          <p>A prova do CFA Level 1 é composta por 180 questões divididas em 10 módulos.</p>
          <p>Por mais que não haja uma divulgação oficial em relação à nota mínima necessária para aprovação, estimamos que você precise atingir no mínimo 70% no desempenho geral para conquistar a sua aprovação. Nosso calendário converge para que você veja a prova como um todo e, desta forma, sua chance de aprovação aumenta.</p>
          <p>O gráfico acima representa seu Score Toro com os acertos de todos os exercícios que você resolveu ao final de cada aula na plataforma, desde a primeira prova de 20 perguntas até a última revisão.</p>
        </ReportText>

        <ReportBreakPage />

        <ReportText type="graph">Desempenho por módulo</ReportText>
        <BartChartV
          linePercent={30}
          linePercentTwo={examConfig.settings.recommendedScore}
          displaySubtitle={'flex'}
          subtitleMin={"seu desempenho"}
          subtitleRecommended={"recomendado"}
          positionSubtitle={'end'}
          includeRevision={includeRevisionByExam}
          data={modulePerfomance}
        />

        <ReportText type='description' style={{ marginTop: '3vw' }}>
          <p>Desta maneira, considerando os pontos que relatamos acima, orientamos que
            {
              recomendedPerformance(modulePerfomance).length > 0
              ?
                <span className='strong-span'> você dê atenção ao(s) módulo(s) {improveMessage(improve)},
                que é(são) o(s) que está(ão) abaixo do recomendado pela Academia Rafael Toro
                </span>
              :
              <span className='strong-span'> siga o cronograma normalmente, pois você está acima da média esperada em todos os módulos</span>
            }

            . Você fará isso utilizando nossas aulas de resumos, aumentando a carga de exercícios diários e, quando possível, a repetição deles. Além disso, ouvir os áudios destes módulos é fundamental.</p>
          <p>Em seguida, vamos apresentar um pouco sobre cada um dos 10 módulos cobrados, e a importância deles para a sua aprovação.</p>
        </ReportText>

        <ReportBreakPage />

        {/* Renderização condicional dos módulos por tipo de exame */}
        {examConfig.examType === 'cfa' ? (
          // Módulos CFA - renderização dinâmica
          getModulesWithPageBreaks([2, 5, 7]).map((item, index) => {
            // Renderiza quebra de página
            if (item.type === 'pageBreak') {
              return <ReportBreakPage key={`break-${index}`} />;
            }
            
            // Renderiza módulo
            return (
              <React.Fragment key={item.id}>
                <TitleModule>{item.title}</TitleModule>
                <ReportText type='description'>
                  <p>{item.description}<br /><strong>Desempenho recomendado: {item.recommendedPerformance}</strong></p>
                </ReportText>
              </React.Fragment>
            );
          })
        ) : (
          // Módulos CFP - 8 módulos (nova estrutura Planejar)
          <>
            <TitleModule>Módulo I – Planejamento Financeiro</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda os princípios, processos e habilidades do planejamento financeiro. Sua prova terá 18 (dezoito) questões, representando 12,9% do total.</p>
              <p><strong>Desempenho recomendado: 80%</strong></p>
            </ReportText>

            <TitleModule>Módulo II – Gestão Financeira</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda conceitos de gestão financeira pessoal e empresarial. Sua prova terá 20 (vinte) questões, representando 14,3% do total.</p>
              <p><strong>Desempenho recomendado: 75%</strong></p>
            </ReportText>

            <ReportBreakPage />

            <TitleModule>Módulo III – Investimentos e Gestão de Ativos</TitleModule>
            <ReportText type='description'>
              <p>É o módulo com a maior quantidade de questões, abordando investimentos e gestão de ativos. Sua prova terá 24 (vinte e quatro) questões, representando 17,1% do total.</p>
              <p><strong>Desempenho recomendado: 80%</strong></p>
            </ReportText>

            <TitleModule>Módulo IV – Aposentadoria</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda planejamento de aposentadoria, incluindo PGBL, VGBL, tributação progressiva e regressiva. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
              <p><strong>Desempenho recomendado: 80%</strong></p>
            </ReportText>

            <ReportBreakPage />

            <TitleModule>Módulo V – Seguros e Gestão de Riscos</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda a aplicabilidade de seguros e conceitos técnicos de gestão de riscos. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
              <p><strong>Desempenho recomendado: 80%</strong></p>
            </ReportText>

            <TitleModule>Módulo VI – Planejamento Tributário</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda tributação de produtos e cálculo de Imposto de Renda. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
              <p><strong>Desempenho recomendado: 75%</strong></p>
            </ReportText>

            <ReportBreakPage />

            <TitleModule>Módulo VII – Planejamento Patrimonial e Sucessório</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda distribuição de herança, herdeiros necessários e doações com cláusulas restritivas. Sua prova terá 17 (dezessete) questões, representando 12,1% do total.</p>
              <p><strong>Desempenho recomendado: 75%</strong></p>
            </ReportText>

            <TitleModule>Módulo VIII – Psicologia do Planejamento Financeiro</TitleModule>
            <ReportText type='description'>
              <p>Módulo que aborda os aspectos psicológicos e comportamentais do planejamento financeiro. Sua prova terá 10 (dez) questões, representando 7,1% do total.</p>
              <p><strong>Desempenho recomendado: 80%</strong></p>
            </ReportText>
          </>
        )}

        <ReportBreakPage />

        <ReportText type="graph">Desempenho em aulas</ReportText>
        <ReportText type='description'>
          <p>Foque nas aulas em <strong style={{ color: '#fcaf20', textDecoration: 'underline' }}>laranja</strong> para elevar ainda mais sua média em cada módulo.</p>
        </ReportText>

        <div style={{ marginBottom: '2vw' }}>
          <LegendChart
            displaySubtitle={'flex'}
            subtitleMin={'Abaixo do Esperado'}
            subtitleRecommended={'Acima do Esperado'}
            colorOne={'#F9DDC0'}
            colorTwo={'#C1C6F2'}
          />
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', flexWrap: 'wrap' }}>
          {
            (report?.performance_per_class ?? []).map((item) => {
              return (
                <BarchartH
                  key={item.titulo}
                  zIndex={0}
                  displaySubtitle={'none'}
                  displayAvaliable={"none"}
                  classNumber={5}
                  percentText={`${Math.round(item.porcentagem)}%`}
                  percent={Math.round(item.porcentagem)}
                  total={truncateText(item.titulo, 45)}
                  fontSize={'1.2vw'}
                  positionPercent={'start'}
                  colorbk1={item.cor}
                  colorText={'#000000'}
                  description={"flex"}
                  textdescription={item.texto}
                  height={"2.258vw"}
                  widthGraph={"45%"}
                />
              )
            })
          }
        </div>

        <ReportBreakPage />

        <ReportText type="description" dangerouslySetInnerHTML={{ 
          __html: suggestion
            ?.replace('{name}', report?.name)
            ?.replace(/CFP/g, examConfig.displayName)
            ?.replace(/Certified Financial Planner/g, examConfig.texts.fullExamName)
        }} />

        <FooterReport style={{marginTop: "50px"}}>
          <div className='logo-gold'>
            <img src={LogoGold} alt='logo' />
          </div>
          <div className='description-footer'>
            <p>{examConfig.texts.footerMessage}</p>
            <p>Um grande abraço dos professores e amigos Rafael Toro, Victório Santi e equipe ART.</p>
          </div>
        </FooterReport>
      </Container>
    </>
  );
}

export default ExamWeeklyReport;
